import { IS_DEV } from '../viteEnv';
import EN_TRANSLATIONS from '@dadohr/shared/locales/en/translation.json';
import FR_TRANSLATIONS from '@dadohr/shared/locales/fr/translation.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Translations are imported at build time from `@dadohr/shared`. See the
 * canonical files in `new-main/packages/shared/src/deprecated/locales/`.
 */
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: EN_TRANSLATIONS },
      fr: { translation: FR_TRANSLATIONS }
    },
    lng: 'en',
    fallbackLng: 'en',
    debug: IS_DEV,
    saveMissing: true,
    saveMissingTo: 'all',
    interpolation: {
      escapeValue: false // react already safes from xss
    },
    whitelist: ['en', 'fr']
  });

export default i18n;
